import { actionCopyDe } from "./actionCopy";

export const formPageCopyDe = {
    entryFor: (label) => `Eintrag für ${label}`,
    next: actionCopyDe.next,
    back: actionCopyDe.back,
    changingAnswers: "Sie ändern Antworten, die Sie bereits gegeben haben",
    submit: actionCopyDe.submit,
    startNow: "Jetzt starten",
    startForm: "Formular starten",
    startingForm: "Formular wird gestartet...",
    formSubmitted: "Formular abgesendet",
    errorsOnPage: (count) =>
        count === 1 ? "Fehler bei 1 Frage auf dieser Seite" : `Fehler bei ${count} Fragen auf dieser Seite`,
    invalidValue: "Ungültiger Wert",
    groupTotal: (total, target) => `Summe: ${total} von ${target}`,
    groupMustTotal: (target) => `Diese Antworten müssen zusammen ${target} ergeben`,
    groupPlaced: (total, target) => `${total} von ${target} verteilt`,
    groupLeft: (n) => `noch ${n}`,
    groupOver: (n) => `${n} zu viel`,
    groupComplete: (target) => `Alle ${target} verteilt`,
    countIncrease: (label) => `Eins mehr bei ${label}`,
    countDecrease: (label) => `Eins weniger bei ${label}`,
    countRequired: "Bitte geben Sie eine Zahl ein, oder 0 für keine",
    answerTooHigh: "Diese Zahl darf nicht größer sein als Ihre vorherige Antwort",
    exclusiveConflict: "Diese Antwort kann nicht mit den anderen Antworten kombiniert werden",
    tickAtLeastOne: "Bitte wählen Sie mindestens eine Antwort aus",
    pageOf: (page, total) => `Seite ${page} von ${total}`,
    carriedNote: "Wir haben dies vom letzten Mal übernommen.",
    questionOf: (current, total) => `Frage ${current} von ${total}`,
    questionsRange: (min, max) => `Fragen ${min} bis ${max}`,
    questionsRangeOf: (min, max, total) => `Fragen ${min} bis ${max} von ${total}`,
    formatProgressLabel: ({ min, max, total, pageNumber, pageTotal }) => {
        let questionPart: string;
        if (min === max) {
            questionPart = `Frage ${min} von ${total}`;
        } else if (max === total) {
            questionPart = `Fragen ${min} bis ${max}`;
        } else {
            questionPart = `Fragen ${min} bis ${max} von ${total}`;
        }

        if (min === max && min === pageNumber && pageTotal === total) {
            return questionPart;
        }

        return `Seite ${pageNumber} von ${pageTotal} - ${questionPart}`;
    },
};
